module.exports = __webpack_public_path__ + "fonts/CircularStd-Book.7afc3a2b.woff2";